export enum SupportedLocaleNumber {
    ES = 0,
    EN = 1,
    FR = 2,
    ZH = 3,
    PT = 4
}

export enum SupportedLanguages {
    ES = 'ES',
    ['ES-CL'] = 'ES-CL',
    EN = 'EN',
    FR = 'FR',
    PT = 'PT',
    CHT = 'CHT'
}